import { render } from "./ProfileSettingsPassword.vue?vue&type=template&id=3ac501dd&scoped=true"
import script from "./ProfileSettingsPassword.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsPassword.vue?vue&type=script&lang=js"

import "@/css/components/profile-settings-password.css?vue&type=style&index=0&id=3ac501dd&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac501dd"]])

export default __exports__